import React from 'react';

export const ErrorCone = () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.6588 96.497H9.93875L6.96875 68.917L17.3687 80.437L18.0287 59.777L25.5588 79.397L32.0987 55.707L44.6588 96.497Z"
        fill="#28BF9A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.5605 96.4999L73.5096 92.5319C75.0008 89.409 77.3348 86.7647 80.2483 84.8971C83.1619 83.0295 86.5392 82.0129 89.9995 81.9619C93.8912 81.9556 97.666 83.2913 100.688 85.7439L113.943 96.4999H71.5605Z"
        fill="#192C55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.5573 89.9971L82.3633 89.4101L83.2273 88.9971L78.0173 72.9971L68.0593 65.6071L72.4773 55.9971L67.2673 39.9971L59.9973 36.9971L48.5973 39.9971L42.8273 55.9971L45.5733 67.6891L36.6873 72.9971L30.5573 89.9971H24.5473L24.4473 95.9971H89.4473L89.5473 89.9971H83.5573Z"
        fill="#C2E2FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117 96V97H3V96H117ZM83.228 89L83.558 90H56V89H83.228Z"
        fill="#192C55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.2625 40H48.5925L54.7225 23H61.7225L67.2625 40ZM72.4775 56L78.0175 73H36.6875L42.8275 56H72.4775Z"
        fill="#116DFF"
      />
    </svg>
  );
};
